export default __webpack_public_path__ + "static/media/hoopia_logo_white.99bcf001.svg";